import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAuthContext } from "../../context/authContext";
import "./ChecklistLayout.css";

function ChecklistLayout({ leftContent, middleContent, rightContent }) {
    const [dadosUsuario, setDadosUsuario] = useState("");
    const { pathname } = useLocation();
    const { operador } = useAuthContext();

    useEffect(() => {
        // Carrega dados do usuário
        //const usu = localStorage.getItem("usuarioLogado");        
        if (operador) {
            //const json = JSON.parse(usu);
            setDadosUsuario(operador);
        }
    }, [pathname, operador]);

    return (
        <>
            {/* Navbar fixo no topo */}
            <div className="navbar">
                {dadosUsuario ? `${dadosUsuario.IDOperador} - ${dadosUsuario.nome}` : "Carregando..."}
            </div>

            {/* Cabeçalho */}
            <div className="header">
                <p>CATEGORIA - Licitação ABC</p>
            </div>

            {/* Layout do conteúdo */}
            <div className="content">
                <div className="grid-container">
                    <div className="grid-item">{leftContent}</div>
                    <div className="grid-item">{middleContent}</div>
                    <div className="grid-item">{rightContent}</div>
                </div>
            </div>
        </>
    );
}

export default ChecklistLayout;
